export default __webpack_public_path__ + "static/media/cg_wide_map.2498ced9.png";